import { render } from "./CPOUserCreation.vue?vue&type=template&id=365df778&scoped=true"
import script from "./CPOUserCreation.vue?vue&type=script&lang=js"
export * from "./CPOUserCreation.vue?vue&type=script&lang=js"

import "./CPOUserCreation.vue?vue&type=style&index=0&id=365df778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365df778"]])

export default __exports__